/**
   * 추가 약관 동의 조회를 위해 웹 토큰을 발급합니다.
   * - 발급된 웹 토큰은 절대 쿠키에 저장하지 않습니다.
   * - 휴면 해제 등 이상 상태 복구/해제 플로우에서 재사용을 위해 오직 로컬 변수에 임시로 캐싱됩니다.
   */
export const getWebToken = async (context) => {
  const {
    logger, infaceAuth, gid, ticket, webToken: cachedWebToken,
  } = context

  if (cachedWebToken) {
    return cachedWebToken
  }

  const webTokenInfo = await infaceAuth.getWebTokenByWebTicketFromGameToken({
    gid,
    webTicket: ticket,
    useCookie: false,
  })

  const { web_token: webToken } = webTokenInfo
  if (!webToken) {
    throw webTokenInfo
  }

  logger.addBreadcrumb({
    type: 'info',
    category: 'sso-for-web-game',
    message: 'Web token received',
    level: 'info',
  })

  return { payload: { webToken } }
}
